import './App.css';
import Navbar from './components/navbar/Navbar';
import Navbar2 from './components/navbar2/Navbar2';
import AllRoutes from './pages/AllRoutes';
import { useLocation, useParams } from 'react-router-dom';

function App() {

  const location = useLocation();
  const currentPage = location.pathname;
  // console.log("check:", currentPage)

  return (
    <>
      {currentPage === "/" && <Navbar />}
      {currentPage === "/services" && <Navbar2 />}
      {currentPage?.includes("/services/") && <Navbar />}
      {currentPage?.includes("/projects/") && <Navbar />}
      {currentPage?.includes("/article/") && <Navbar />}
      {currentPage === "/about" && <Navbar2 />}
      {currentPage === "/contact" && <Navbar2 />}
      {currentPage === "/projects" && <Navbar2 />}
      {currentPage === "/blogs" && <Navbar />}

      <AllRoutes />
    </>

  );
}

export default App;
